import React, { ChangeEvent, FormEvent, FunctionComponent, useState } from 'react';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import PlacesAutocomplete from '@gojob/ui-bits/PlacesAutocomplete';
import TranslationProvider from '@gojob/ui-bits/PlacesAutocomplete/TranslationProvider';
import { Option } from '@gojob/ui-bits/PlacesAutocomplete/useRemoteOptions';

import SearchButton from 'src/components/SearchButton';
import KeywordField from 'src/components/SearchForm/KeywordField';
import useTranslation from 'src/translations/useTranslation';

export interface SearchFormProps extends FlexProps<'form'> {
  defaultSearchKeyword?: string;
  defaultPlace?: Option | null;
  onSearch?: (search?: string, place?: Option | null) => void;
}

const SearchForm: FunctionComponent<SearchFormProps> = (props) => {
  const { defaultSearchKeyword = '', defaultPlace = null, onSearch, ...other } = props;

  const [searchKeyword, setSearchKeyword] = useState(defaultSearchKeyword);
  const [place, setPlace] = useState<Option | null | undefined>(defaultPlace);

  const t = useTranslation();

  const handleOnKeywordChange = (e?: ChangeEvent<HTMLInputElement>) => {
    const value = e?.target?.value || '';
    setSearchKeyword(value);
  };
  const handleOnKeywordClear = () => handleOnKeywordChange();

  const handleOnSubmit = (e?: FormEvent) => {
    e?.stopPropagation();
    e?.preventDefault();
    onSearch?.(searchKeyword, place);
  };

  return (
    <TranslationProvider translationFunction={t}>
      <Flex<'form'>
        data-testid="SearchForm"
        as="form"
        flex="0 0 auto"
        margin={4}
        flexDirection="column"
        onSubmit={handleOnSubmit}
        {...other}
      >
        <Flex flexDirection="column">
          <Flex flexDirection="column" margin={[2, 0]}>
            <KeywordField
              value={searchKeyword}
              onChange={handleOnKeywordChange}
              onClear={handleOnKeywordClear}
            />
          </Flex>

          <Flex flexDirection="column" margin={[2, 0]}>
            <PlacesAutocomplete defaultValue={place} id="city" onChange={setPlace} />
          </Flex>
        </Flex>

        <Flex margin={[2, 0]}>
          <SearchButton css={{ width: '100%' }} />
        </Flex>
      </Flex>
    </TranslationProvider>
  );
};

export default SearchForm;
